import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { DEFAULT_TRANSFER_USER_PACKAGE_PREVIEW } from "../../constants/input-entries-constants";
import { TTransferPackageType, TTransferUserPackagePreview } from "../../Types";
import { post } from "../axios-post";

export const apiCallGetTransferUserPackagePreview = async ({
  fromUserId,
  toUserId,
  type
}: {
  fromUserId: number;
  toUserId: number;
  type: TTransferPackageType;
}): Promise<{
  data: TTransferUserPackagePreview;
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<{
    data: TTransferUserPackagePreview;
  }>(`developer/getTransferUserPackagePreview`, {
    fromUserId,
    toUserId,
    type
  });

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data.data,
      status: "OK",
      code: "SUCCESS"
    };
  } else {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: DEFAULT_TRANSFER_USER_PACKAGE_PREVIEW,
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  }
};
